import { Link } from "react-router";

import { PageHeader } from "@/components/layout/PageHeader";
import { EmptyState } from "@/components/state/EmptyState";
import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";

/** Een route die niet bestaat — in tegenstelling tot een scherm dat nog komt. */
export function NotFound() {
  return (
    <>
      <PageHeader
        title="Pagina niet gevonden"
        breadcrumbs={[{ label: "PortefeuilleAtlas", to: "/" }, { label: "Niet gevonden" }]}
        exportDisabledReason="Er is niets te exporteren"
      />
      <Card>
        <EmptyState
          title="Deze pagina bestaat niet"
          description="Het adres klopt niet, of het scherm is verplaatst. Gebruik de navigatie links."
          action={
            <Link to="/">
              <Button variant="primary">Naar het dashboard</Button>
            </Link>
          }
        />
      </Card>
    </>
  );
}
